// Portal step names
export const STEPS = {
  LOGIN:          'login',
  REGISTER:       'register',
  DASHBOARD:      'dashboard',
  BOOKINGS:       'bookings',
  BOOKING_DETAIL: 'booking-detail',
  SALES:          'sales',
  SALE_DETAIL:    'sale-detail',
  GIFTCARDS:      'giftcards',
  PACKAGES:       'packages',
  MEMBERSHIPS:    'memberships',
  WALLET:         'wallet',
  FORMS:          'forms',
  FORM_DETAIL:    'form-detail',
  BOOK_REBOOK_PICK:  'book-rebook-pick',
  // Booking flow
  BOOK_CATEGORIES:   'book-categories',
  BOOK_ENHANCEMENTS: 'book-enhancements',
  BOOK_PROVIDER:     'book-provider',
  BOOK_ADD_ANOTHER:  'book-addAnother',
  BOOK_DATETIME:     'book-datetime',
  BOOK_CONTACT:      'book-contact',
  BOOK_CONFIRM:      'book-confirm',
  BOOK_SUCCESS:      'book-success',
  BOOK_PAYMENT:      'book-payment',
  BOOK_PENDING_TEXT: 'book-pending-text',
  // Gift card flow
  GC_DETAILS:        'gc-details',
  GC_PAYMENT:        'gc-payment',
  GC_SUCCESS:        'gc-success',
  // Package flow
  PKG_LIST:          'pkg-list',
  PKG_CONTACT:       'pkg-contact',
  PKG_PAYMENT:       'pkg-payment',
  PKG_SUCCESS:       'pkg-success',
  // Membership enrollment flow
  MEM_LIST:          'mem-list',
  MEM_CONTACT:       'mem-contact',
  MEM_PAYMENT:       'mem-payment',
  MEM_SUCCESS:       'mem-success',
  // Recurring appointments
  RECURRING:         'recurring',
  RECURRING_DETAIL:  'recurring-detail',
} as const;

// Timing constants (milliseconds)
export const TIMING = {
  MOCK_LOAD_DELAY:   50,
  TIME_PICK_DELAY:   280,
  PROMO_DELAY:       300,
  BOOKING_DELAY:     400,
  PANEL_RESET_DELAY: 400,
  PKG_MOCK_DELAY:    1200,
  GC_MOCK_DELAY:     1800,
} as const;
